import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { AVERAGE_TICKET } from '../../constants';
import { AverageTicketQuery } from '../queries';

export class AverageTicketCalculator extends Calculator {
  kpiType = AVERAGE_TICKET

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(AverageTicketQuery, this.currentPeriod);
    let props;
    if (this.previousPeriod) {
      const previousResponse = await this.executeUncubeQuery(AverageTicketQuery, this.previousPeriod);
      props = this.getData(currentResponse.data.result[0][1] / currentResponse.data.result[0][0], previousResponse.data.result[0][1] / previousResponse.data.result[0][0]);
    } else props = this.getDataIfNoPreviousPeriod(currentResponse.data.result[0][1] / currentResponse.data.result[0][0]);
    return this.getModelToInstance(props);
  }

  getValueOfKpi(rawKpi) {
    if (!Number.isNaN(rawKpi)) {
      return Math.trunc(rawKpi * 100) / 100;
    }
    return 0;
  }
}
